import { useState } from 'react';
import { STabs } from '@setvi/shared/components';
import { FilterIcon, ListIcon } from '@setvi/shared/components/sicons';
import { Container, TabsContainer } from './styled';
import { FacetsProps } from '../facets';
import { FiltersContent } from './filters';
import { CategoriesContent, CategoriesContentProps } from './categories';

enum Tabs {
  Categories,
  Filters
}

interface BottomLeftWrapperProps {
  filtersProps: FacetsProps;
  categoriesProps: CategoriesContentProps;
}

export const BottomLeftWrapper = ({
  filtersProps,
  categoriesProps
}: BottomLeftWrapperProps) => {
  const [activeTab, setActiveTab] = useState(Tabs.Filters);
  return (
    <Container>
      <TabsContainer>
        <STabs
          variant="fullWidth"
          divider={false}
          tabsList={[
            {
              label: 'Categories',
              value: Tabs.Categories,
              icon: <ListIcon />
            },
            {
              label: 'Filters',
              value: Tabs.Filters,
              icon: <FilterIcon />
            }
          ]}
          handleTabChange={value => setActiveTab(value)}
          type="rounded"
          currentTab={activeTab}
          tabStyle={{
            padding: '8px 12px'
          }}
        />
      </TabsContainer>
      {activeTab === Tabs.Categories && (
        <CategoriesContent {...categoriesProps} />
      )}
      {activeTab === Tabs.Filters && <FiltersContent {...filtersProps} />}
    </Container>
  );
};
